module.exports = __webpack_public_path__ + "static/media/CreditCardIcon.3763d38b.svg";